import type { ReactNode } from "react";
import { EXERCISES, type ExerciseId } from "@/lib/exercises";
import { useEffectOnce } from "@/lib/use-effect-once";

/**
 * Renders the exercise once a session is in progress: starts the first
 * session, or a new one when the previous session was finished.
 */
export const ExerciseSession = ({
  id,
  children,
}: {
  id: ExerciseId;
  children: ReactNode;
}) => {
  const { store } = EXERCISES[id];
  const status = store.useSessionStatus();

  useEffectOnce({
    effect: () => {
      if (status === "NO_SESSIONS") store.initialize();
      else if (status === "FINISHED") store.startNewSession();
    },
  });

  if (status !== "IN_PROGRESS") return null;

  return children;
};
